const HOST = '/lms/api/personalcard'

export { HOST }